import { EntityIdentifier } from "module/entity/types";

export const getEntityIdentifierKey = ({
  id,
  type,
}: EntityIdentifier): string => `${type}--${id}`;
